import { Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  selector: 'sbnb-strly',
  template: `
    <sbnb-apps-detail-page
      vendorCode="waive_it"
      name="Strly"
      logoTile="/assets/images/apps/strly-logo.png"
      builtBy="Strly"
      builtByLink=" https://strly.com/"
      [categories]="['Guest verification']"
      [permissions]="[AppPermission.propertyListingRead, AppPermission.enrichmentRead]"
      email="hello@strly.com"
      [beta]="false"
      [helpArticles]="[
        {
          id: '10134566',
          title:
            'Connect Hospitable with Strly for guest verifications'
        }
      ]">
      <ng-container description>

        <p class="!mb-2">
          Strly uses damage waivers to protect STR properties from accidental damages, with no deductibles, no minimums or excluded items, this comprehensive coverage gives the hosts peace of mind that damages will be resolved quickly and with absolutely no guest contact.
A completely flexible coverage that gives the host the ability to create custom automations, and integrate Strly directly into their current business processes.
        </p>


        <p class="!mb-2">
   With Strly, there are no monthly costs, listing fees, contracts, or hidden costs. This unmatched transparency gives short-term rental hosts around the world the confidence they need to safeguard their investments against accidental damage.
Strly is offering a FREE guest verification tool, this is non-invasive to guests and will give the hosts that all-important comfort!
        </p>
      </ng-container>
    </sbnb-apps-detail-page>
  `,
})
export class StrlyComponent {
  public AppPermission = AppPermission;
}
